import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggerService } from '../services/logger.service';

/**
 * Global Unhandled Exception & Crash Handler for Angular.
 * Intercepts all unhandled client errors, extracts error traces and context,
 * and transmits them to the centralized logging backend.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logger = inject(LoggerService);

  handleError(error: any): void {
    // 1. Extract error details
    const message = error?.message || (typeof error === 'string' ? error : 'Unhandled client exception');
    const stackTrace = error?.stack || (error?.error?.stack ? String(error.error.stack) : undefined);

    // 2. Transmit to backend logger
    this.logger.error(
      `Unhandled Client Exception: ${message}`,
      stackTrace,
      {
        errorName: error?.name,
        ngOriginalError: error?.ngOriginalError ? String(error.ngOriginalError) : undefined
      }
    );

    // 3. Keep original console error for local debugging
    console.error('Captured by GlobalErrorHandler:', error);
  }
}
